<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>学生管理</el-breadcrumb-item>
    <el-breadcrumb-item>预约列表</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
    <el-row>
      <el-col :span="3"><span>查看时间</span></el-col>
      <el-col :span="3">
        <el-select v-model="serData" placeholder="时间筛选">
      <el-option label="今天" value="0"></el-option>
      <el-option label="最近两天" value="-1"></el-option>
      <el-option label="最近三天" value="-3"></el-option>
      <el-option label="最近一周" value="-7"></el-option>
      <el-option label="全部" value=""></el-option>
    </el-select></el-col>
      <!-- <el-col :span="1"><span>听课人</span></el-col>
      <el-col :span="2"><el-input v-model="lecturesUser"></el-input></el-col> -->
      <el-col :span="2"><el-button type="primary" @click="VileaDate">查询</el-button></el-col>
      <el-col :span="3"> <p class="lableforSearch">查询到{{apponinList.length}}条数据</p></el-col>
      
    </el-row>
  <el-table
      ref="ieltsList"
      :data="apponinList"
      border
      show-overflow-tooltip="true"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        prop="appointmentDate"
        :show-overflow-tooltip="true"
        label="预约时间"
        width="180">
      </el-table-column>
       <el-table-column
        prop="adress"
        :show-overflow-tooltip="true"
        label="预约地点"
        width="180">
      </el-table-column>
      <el-table-column
      prop="content"
      :show-overflow-tooltip="true"
      label="预约内容"
      width="180">
    </el-table-column>
      <el-table-column
        prop="teacherGroupName"
        :show-overflow-tooltip="true"
        label="预约老师"
        width="180">
      </el-table-column>
      <el-table-column
        prop="name"
        :show-overflow-tooltip="true"
        label="学生姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="mobiles"
        :show-overflow-tooltip="true"
        label="手机号"
        width="180">
      </el-table-column>
      <el-table-column
      prop="isSuccess"
      label="是否超过约定时间"
      width="150"
      :formatter="stateFormat">
    </el-table-column>

    <el-table-column
      label="点评"
      width="90">
        <template slot-scope="scope" >
<!-- <el-button  @click="deleteMenus(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button> -->
   <el-button v-show="scope.row.isSuccess==1" @click="updateApp(scope.row)"  >
    <svg class="icon" aria-hidden="true"> 
      <use xlink:href="#icon-xiugai" v-if="scope.row.teacherMark==null"></use>
      <use xlink:href="#icon-chakan2" v-if="scope.row.teacherMark!=null"></use>
    </svg></el-button>
   </template>
    </el-table-column>

    </el-table>
  </el-card>
  <el-dialog
  title="点评打分"
  :visible.sync="dialogUpdate"
  width="25%"
  destroy-on-close>
  <el-form :model="updateForm" status-icon :rules="rulesUpdate" ref="ruleUpdate" label-width="100px" class="demo-ruleForm">
<el-form-item label="评价留言：" prop="teacherRemark"><el-input  :disabled="isMark!=null?true:false"  v-model="updateForm.teacherRemark" type="textarea" ></el-input></el-form-item>
<el-form-item label="打分：" prop="teacherMark"><el-input type="number" :disabled="isMark!=null?true:false"  v-model="updateForm.teacherMark"></el-input></el-form-item>
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogUpdate = false">取 消</el-button>
    <el-button v-if="isMark==null" type="primary" @click="subUpdateForm">提交</el-button>
  </span>
</el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    created(){
     this.getAppoinment()
    },
  data(){
      return{
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() > Date.now();
          } },
          dialogUpdate:false,
          textList:[],
          isMark:'',
          serData:'',
          apponinList:[],
          updateForm:{
          appointmentId:'',
          teacherMark:'',
          teacherRemark:'',
        },
        rulesUpdate:{
          teacherMark:[
          { required: true, message: '请打分', trigger: 'blur' },
          ]
        },
      }
  },
  methods:{
    getAppoinment(){
    // alert(this.$formateDate.ShowDate('-2'))
    this.axios.post("/apponintment/selectTeacherApponintment?teacherId="+JSON.parse(localStorage.getItem("user")).userid+"&isSuccess="+"1")
        .then((resp) => {
          if (resp.data.status == 1) {
           console.log(resp.data.result)
           this.apponinList=resp.data.result
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
  },
subUpdateForm(){
    this.$refs.ruleUpdate.validate((resp=>{
      if(!resp)
      return
      let config = {headers: { "Content-Type": "application/json" }} 
    this.axios.post("/apponintment/updateByAppointmentId",this.updateForm,config)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.$message.success("修改成功");
            this.getAppoinment()
             this.$refs.ruleUpdate.resetFields()
             this.dialogUpdate=false
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
    })) 
},VileaDate(){
  if(this.textList.length<=0){
            this.textList=this.apponinList
          }
          this.apponinList=this.textList
           let nowDate=this.$formateDate.formateDate2(new Date())
          this.apponinList=this.apponinList.filter((item)=>{
           if(this.serData!=''){
            let data1=item.appointmentDate.slice(0,10)
            let data2=this.$formateDate.ShowDate(this.serData)
            return nowDate<=data1 && data1<=data2
           }else{
            return true
           }     
  
          })
        

},
    stateFormat(row, column) {
      if (row.isSuccess === null) {
        return '暂未预约'
      } else if(row.checkWork==1){
        return '预约成功'
      }else  {
        return '已查看'
      }} ,updateApp(data){
  this.dialogUpdate=true
  this.updateForm.appointmentId=data.appointmentId
  this.updateForm.teacherMark=data.teacherMark
  this.updateForm.teacherRemark=data.teacherRemark
  this.isMark=data.teacherMark
},
      stateFormat(row, column) {
 if(row.appointmentDate<this.$formateDate.formateDate(Date.now())){
      return '是'
    }else  {
      return '否'
    }} ,
  },
  
  }
  </script>
  
  <style scoped>

     .lableforSearch{
      margin-top:8px;
      color:grey
}
  
  </style>


// WEBPACK FOOTER //
// src/components/work/teacher/VieTeacherApponintment.vue